<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ product.name }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ product.sku }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ totalPcs }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      {{ totalSales }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
      <ProductManager :acc-product-id="product.id" />
    </td>
  </tr>
</template>

<script>
import numbro from '@/utils/numbro';
import ProductManager from './product-manager.vue';

export default {
  components: {
    ProductManager,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalPcs() {
      return this.product?.accOrderLineItemsCount || '?';
    },
    totalSales() {
      if (typeof this.product?.accOrderLineItemsSumTotal === 'undefined') {
        return '?';
      }

      return numbro(this.product?.accOrderLineItemsSumTotal).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
  },
};
</script>
